import { render, staticRenderFns } from "./BulkPromo.vue?vue&type=template&id=2ae5813f"
import script from "./BulkPromo.vue?vue&type=script&lang=js"
export * from "./BulkPromo.vue?vue&type=script&lang=js"
import style0 from "./BulkPromo.vue?vue&type=style&index=0&id=2ae5813f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports